import React from 'react';

import ElectricalIcon from '@/components/icons/Electrical.svg';
import FoodStorageIcon from '@/components/icons/FoodStorage.svg';
import GeneratorUseIcon from '@/components/icons/GeneratorUse.svg';
import PawPrintIcon from '@/components/icons/PawPrint.svg';
import RVIcon from '@/components/icons/RV.svg';
import SewerIcon from '@/components/icons/Sewer.svg';
import TrailerIcon from '@/components/icons/Trailer.svg';
import WaterIcon from '@/components/icons/Water.svg';

import css from './Accommodations.module.css';

interface IProps {
  accommodations: Record<string, string | boolean>;
}

const Accommodations: React.FC<IProps> = ({ accommodations }) => {
  const options = [
    {
      label: 'Electrical hookup',
      value: accommodations.electrical_hookup,
      icon: <ElectricalIcon />,
    },
    {
      label: 'Water hookup',
      value: accommodations.water_hookup,
      icon: <WaterIcon />,
    },
    {
      label: 'Generator use',
      value: accommodations.generator_use,
      icon: <GeneratorUseIcon />,
    },
    {
      label: 'Food storage',
      value: accommodations.food_storage,
      icon: <FoodStorageIcon />,
    },
    {
      label: 'Sewer hookup',
      value: accommodations.sewer_hookup,
      icon: <SewerIcon />,
    },
    {
      label: 'Dogs & cats',
      value: accommodations.pet_friendly,
      icon: <PawPrintIcon />,
    },
  ];

  return (
    <>
      <h2 className="mb-2 text-xl font-medium leading-tight">Camping Accommodations</h2>
      <div className={css.max_lengths}>
        <div className={css.rv_limit}>
          <div className={css.rv_limit_value}>
            <span>{accommodations.max_rv_length}&#39;</span>
            <RVIcon className={css.icon} />
          </div>
          <div className={css.rv_limits_description}>
            <span>Max RV length</span>
          </div>
        </div>
        <div className={css.rv_limit}>
          <div className={css.rv_limit_value}>
            <span>{accommodations.max_trailer_length}&#39;</span>
            <TrailerIcon className={css.icon} />
          </div>
          <div className={css.rv_limits_description}>
            <span>Max trailer Length</span>
          </div>
        </div>
      </div>

      <div className={css.options}>
        {options.map(option => (
          <div
            key={option.label}
            className={`${css.option} ${option.value ? '' : css.strikethrough}`}>
            <div className={css.icon}>{option.icon}</div>
            <span>{option.label}</span>
            <span className={css.line} />
          </div>
        ))}
      </div>
    </>
  );
};

export default Accommodations;
